export default {
  AllMedicalCancer: [],
  selectedMedicalForUpdate: {},
};
